
const EventMixin = {
  props: ['mediaObject']
}

export default EventMixin



// WEBPACK FOOTER //
// ./src/components/socialMedia/ExternalMediaObject.js